// frontend/src/api/parts.js
import { apiClient } from './index';

const partsApi = {
  getAllParts: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    const response = await apiClient.get(`/parts/?${params.toString()}`);
    return response || [];
  },

  getPartById: async (partId) => {
    return await apiClient.get(`/parts/${partId}`);
  },

  getRelatedParts: async (partId) => {
    return await apiClient.get(`/parts/${partId}/related`);
  },

  // --- NEW: MORE FROM SELLER ---
  getMoreFromSeller: async (partId) => {
    return await apiClient.get(`/parts/${partId}/seller-items`);
  },

  // --- MANAGER ENDPOINTS ---
  getMyParts: async () => {
    try {
        const response = await apiClient.get('/parts/user/mine');
        console.log("API RAW RESPONSE (getMyParts):", response);
        // Ensure we always return an array
        if (Array.isArray(response)) return response;
        if (response && Array.isArray(response.data)) return response.data;
        return [];
    } catch (error) {
        console.error("API ERROR (getMyParts):", error);
        return []; // Return empty array on error to prevent crash
    }
  },

  createMyPart: async (partData) => {
    return await apiClient.post('/parts/user/mine', partData);
  },

  updateMyPart: async (partId, partData) => {
    return await apiClient.put(`/parts/user/mine/${partId}`, partData);
  },

  deleteMyPart: async (partId) => {
    return await apiClient.delete(`/parts/user/mine/${partId}`);
  }
};

export { partsApi };